import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { useLocation } from 'react-router-dom';

import { getAssignmentById, getGoogleAssignmentEndDate } from '../../actions/assignment';
import { setGoogleCourseWorkId } from '../../actions/application';
import ClassWorkLoginComponent from '../../components/classwork-login-component';
import ClassworkPreview from '../../components/classwork-preview';
import { requestAccessToken, resumeGoogleLogin } from '../../actions/google-auth';

export const ClassWorkPage = ({
    assignment,
    googleUserInfo,
    googleUserStatus,
    getAssignmentById,
    getGoogleAssignmentEndDate,
    requestAccessToken,
    resumeGoogleLogin,
    setGoogleCourseWorkId,
}) => {
    const isGooglePreview = navigator.userAgent.includes('Google Web Preview');

    const location = useLocation();
    let assignmentId = sessionStorage.getItem('id');

    if (!assignmentId) {
        assignmentId = new URLSearchParams(location.search).get('id');
        sessionStorage.setItem('id', assignmentId);
    }

    return !isGooglePreview ? (
        <ClassWorkLoginComponent
            assignment={assignment}
            assignmentId={assignmentId}
            googleUserInfo={googleUserInfo}
            googleUserStatus={googleUserStatus}
            getAssignmentById={getAssignmentById}
            setGoogleCourseWorkId={setGoogleCourseWorkId}
            requestAccessToken={requestAccessToken}
            resumeGoogleLogin={resumeGoogleLogin}
            getGoogleAssignmentEndDate={getGoogleAssignmentEndDate}
        />
    ) : (
        <ClassworkPreview assignment={assignment} assignmentId={assignmentId} getAssignmentById={getAssignmentById} />
    );
};

ClassWorkPage.propTypes = {
    assignment: PropTypes.object,
    googleUserInfo: PropTypes.object,
    googleUserStatus: PropTypes.shape({
        error: PropTypes.bool,
        fetching: PropTypes.bool,
        loaded: PropTypes.bool,
    }),
    getAssignmentById: PropTypes.func,
    getGoogleAssignmentEndDate: PropTypes.func,
    requestAccessToken: PropTypes.func,
    resumeGoogleLogin: PropTypes.func,
    setGoogleCourseWorkId: PropTypes.func,
};

function mapStateToProps(state) {
    return {
        assignment: state.assignment,
        googleUserInfo: state.googleAuth.userInfo,
        googleUserStatus: state.googleAuth.status,
    };
}

const actionCreators = {
    getAssignmentById,
    setGoogleCourseWorkId,
    getGoogleAssignmentEndDate,
    requestAccessToken,
    resumeGoogleLogin,
};

export default connect(mapStateToProps, actionCreators)(ClassWorkPage);
